import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { usePageMetadata } from "../context/PageMetadataContext";

const PrivacyPolicy: React.FC = () => {
    const {setHeading,setTitle,setDescription} = usePageMetadata();
          useEffect(() => {
            setHeading("Privacy Policy");
            setTitle("Privacy Policy for PiScan");
            setDescription("Learn how we collect, use, and protect your information when you use PiScan.");
          }, [setTitle, setDescription, setHeading]);
  return (
    <div className="white-zone content-page py-5">
      <h1 className="mb-4">Privacy Policy</h1>
      <p><strong>Effective Date:</strong> {new Date().toLocaleDateString()}</p>

      <section className="mb-4">
        <h2>1. Introduction</h2>
        <p>
          Welcome to <strong>PiScan</strong> (the "Website"), accessible at <a href="https://piscan.io" className="text-primary">https://piscan.io</a>. 
          Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our Website.
        </p>
      </section>

      <section className="mb-4">
        <h2>2. Information We Collect</h2>
        <p>PiScan is a blockchain explorer that primarily displays publicly available blockchain data. However, we may collect the following information:</p>
        <ul>
          <li><strong>Log Data:</strong> IP addresses, browser type, and access times for security and analytics.</li>
          <li><strong>Cookies:</strong> We use cookies to improve user experience (see Section 6).</li>
          <li><strong>Voluntary Information:</strong> If you contact us, we may store your email address and any provided details.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>3. How We Use Your Information</h2>
        <p>We use collected data for the following purposes:</p>
        <ul>
          <li>To operate and maintain PiScan.</li>
          <li>To improve our services based on usage patterns.</li>
          <li>To ensure security and prevent fraudulent activities.</li>
          <li>To respond to inquiries and support requests.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>4. Public Blockchain Data</h2>
        <p>
          PiScan does not control blockchain transactions. All data displayed on the Website (e.g., transactions, addresses, smart contract interactions) 
          is publicly available on the blockchain and is not considered private information.
        </p>
      </section>

      <section className="mb-4">
        <h2>5. Sharing of Information</h2>
        <p>We do not sell or share your personal data, except in the following cases:</p>
        <ul>
          <li><strong>Legal Requirements:</strong> If required by law or regulatory authorities.</li>
          <li><strong>Security Measures:</strong> To prevent fraud or unauthorized activity.</li>
          <li><strong>Service Providers:</strong> We may share anonymized data with analytics providers.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>6. Cookies and Tracking</h2>
        <p>
          We use cookies to improve user experience. You can disable cookies in your browser settings, but some features of PiScan may not function properly.
        </p>
      </section>

      <section className="mb-4">
        <h2>7. Data Security</h2>
        <p>
          We implement security measures to protect against unauthorized access, but no method of transmission over the internet is 100% secure.
        </p>
      </section>

      <section className="mb-4">
        <h2>8. Third-Party Links</h2>
        <p>
          PiScan may contain links to third-party websites. We are not responsible for their privacy policies or practices.
        </p>
      </section>

      <section className="mb-4">
        <h2>9. Third-Party Advertising</h2>
        <p>
          We may display advertisements provided by third parties. These third parties may collect data such as IP address, browser type, or interaction events for analytics or targeting purposes.
        </p>
        <p>
          We do not have control over the content or behavior of these third-party ads. Please review their respective privacy policies before interacting.
        </p>
        <p>
          <strong>Important:</strong> If you prefer not to have your data collected by third-party advertisers, you can:
        </p>
        <ul>
          <li>Use browser privacy settings or extensions that block tracking</li>
          <li>Disable cookies in your browser settings (though this may affect site functionality)</li>
          <li>Use ad-blocking software (note that this may impact our ability to maintain free services)</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2>10. Updates to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Changes will be posted on this page, and continued use of PiScan after updates constitutes your acceptance.
        </p>
      </section>

      <section className="mb-4">
        <h2>11. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us at:
        </p>
        <p>Email: <a href="mailto:contact@piscan.io" className="text-primary">contact@piscan.io</a></p>
      </section>

      <hr />
      <p className="text-muted">Last Updated: {new Date().toLocaleDateString()}</p>
    </div>
  );
};

export default PrivacyPolicy;
